export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6382.97144a76.jpg";